import { z } from 'zod/v4';

import { endpoint } from '../http/endpoint';
import { PCBCredentialsDTORuntype, UserPasswordCredentialsInputDTORuntype } from './pcbManufacturerBackendTypes';

export const pcbManufacturersEndpoints = {
    'GET /3rdparty/pcb-manufacturer/credentials/:manufacturerId': endpoint({
        description: 'Returns full credentials for the given PCB manufacturer API integration',
        pathParams: z.object({ manufacturerId: z.string() }),
        queryParams: z.undefined(),
        requestBody: z.undefined(),
        responseBody: z.object({ data: PCBCredentialsDTORuntype.nullable() }),
    }),
    'POST /3rdparty/pcb-manufacturer/credentials/:manufacturerId': endpoint({
        description: 'Uploads credentials for the given PCB manufacturer API integration',
        pathParams: z.object({ manufacturerId: z.string() }),
        queryParams: z.undefined(),
        requestBody: UserPasswordCredentialsInputDTORuntype,
        responseBody: z.object({ data: PCBCredentialsDTORuntype.nullable() }),
        invalidates: ['GET /3rdparty/pcb-manufacturer/credentials/:manufacturerId'],
    }),
    'PATCH /3rdparty/pcb-manufacturer/credentials/:manufacturerId': endpoint({
        description: 'Updates credentials for the given PCB manufacturer API integration',
        pathParams: z.object({ manufacturerId: z.string() }),
        queryParams: z.undefined(),
        requestBody: UserPasswordCredentialsInputDTORuntype,
        responseBody: z.object({ data: PCBCredentialsDTORuntype.nullable() }),
        invalidates: ['GET /3rdparty/pcb-manufacturer/credentials/:manufacturerId'],
    }),
    'DELETE /3rdparty/pcb-manufacturer/credentials/:manufacturerId': endpoint({
        description: 'Deletes existing credentials for the given PCB manufacturer API integration',
        pathParams: z.object({ manufacturerId: z.string() }),
        queryParams: z.undefined(),
        requestBody: z.undefined(),
        responseBody: z.object({ deleted: z.number() }),
    }),
};
